import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { CollapsableRowComponent } from './collapsable-row/collapsable-row.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalInfoComponent } from './modal-info/modal-info.component';
import { ModalActionableComponent } from './modal-actionable/modal-actionable.component';
import { ApcActionCardComponent } from './apc-action-card/apc-action-card.component';
import { DatatableGenericComponent } from './datatable/datatable.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { InlineSVGModule } from 'ng-inline-svg';
import { SwitchComponent } from './form/switch/switch.component';
import { AllActionsComponent } from './apc-action-card/buttons/multi-actions/multi-actions.component';
import { SemiActionsComponent } from './apc-action-card/buttons/mono-actions/mono-actions.component';
import { CustomFieldModalComponent } from './modal-templates/custom-field-modal/custom-field-modal.component';
import { FileModalComponent } from './modal-templates/file-modal/file-modal.component';
import { LinkModalComponent } from './modal-templates/link-modal/link-modal.component';
import { NoteModalComponent } from './modal-templates/note-modal/note-modal.component';
import { SaveBackActionsComponent } from './apc-action-card/buttons/save-back-actions/save-back-actions.component';
import { NavbarBigComponent } from './navbars/navbar-big/navbar-big.component';
import {  RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NavbarSmallComponent } from './navbars/navbar-small/navbar-small.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CreateElementButtonsComponent } from './create-element-buttons/create-element-buttons.component';
import { AdminCrudButtonsComponent } from './apc-action-card/buttons/admin-crud-buttons/admin-crud-buttons.component';
import { LoadingComponent } from './loading/loading.component';
import { isEllipsisActiveDirective } from './directives/isEllipsisActiveDirective.directive';
import { CheckPermissionDirective } from './directives/permissions.directive';
import { ClickOutsideModule } from 'ng-click-outside';
import { InputComponent } from './form/input/input.component';
import { ApcSectionAnchorsComponent } from './apc-section-anchors/apc-section-anchors.component';
import { BasicCrudModalComponent } from './basic-crud-modal/basic-crud-modal.component';
import { CodeValueFormComponent } from './basic-crud-modal/admin/code-value-form/code-value-form.component';
import { MultiFormsComponent } from './multi-forms/multi-forms.component';
import { SelectComponent } from './form/select/select.component';
import { HelpIconComponent } from './form/help-icon/help-icon.component';
import { FiltersComponent } from './datatable/filters/filters.component';
import { NgxCurrencyModule } from 'ngx-currency';
import { HighLightPipe } from './directives/highlightPipe.directive';

import { TagInputModule } from 'ngx-chips';
import { ErrorDetailComponent } from '../user/errors/errors/error-detail/error-detail.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { OrderTypeFormComponent } from './basic-crud-modal/admin/order-type-form/order-type-form.component';
import { DataComponent } from '../user/order/data/data.component';
import { ProductFormComponent } from './basic-crud-modal/admin/product-form/product-form.component';
import { ProgressBarModule } from 'angular-progress-bar';
import { DepartmentFormComponent } from './basic-crud-modal/admin/department-form/department-form.component';
import { BatchOrderEditComponent } from '../user/dashboard/orders/batch-order-edit/batch-order-edit.component';
import { BatchBudgetEditComponent } from '../user/dashboard/budgets/batch-budget-edit/batch-budget-edit.component';
import { AutoFocus } from './directives/auto-focus.directive';

@NgModule({
  declarations: [
    CollapsableRowComponent,
    DatatableGenericComponent,
    ModalInfoComponent,
    ModalActionableComponent,
    ApcActionCardComponent,
    SwitchComponent,
    AllActionsComponent,
    SemiActionsComponent,
    CustomFieldModalComponent,
    FileModalComponent,
    LinkModalComponent,
    NoteModalComponent,
    SaveBackActionsComponent,
    NavbarBigComponent,
    NavbarSmallComponent,
    CreateElementButtonsComponent,
    AdminCrudButtonsComponent,
    LoadingComponent,
    isEllipsisActiveDirective,
    CheckPermissionDirective,
    AutoFocus,
    InputComponent,
    ApcSectionAnchorsComponent,
    BasicCrudModalComponent,
    CodeValueFormComponent,
    MultiFormsComponent,
    SelectComponent,
    HelpIconComponent,
    FiltersComponent,
    HighLightPipe,
    ErrorDetailComponent,
    OrderTypeFormComponent,
    DataComponent,
    ProductFormComponent,
    DepartmentFormComponent,
    BatchOrderEditComponent,
    BatchBudgetEditComponent
    ],
  imports: [
    CommonModule,
    RouterModule,
    ClickOutsideModule,
    NgbModule,
    NgxDatatableModule,
    InlineSVGModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    NgxCurrencyModule,
    TagInputModule,
    NgxJsonViewerModule,
    ProgressBarModule
    ],
  exports: [
    CollapsableRowComponent,
    DatatableGenericComponent,
    ModalInfoComponent,
    ModalActionableComponent,
    ApcActionCardComponent,
    InlineSVGModule,
    SwitchComponent,
    AllActionsComponent,
    SemiActionsComponent,
    CustomFieldModalComponent,
    FileModalComponent,
    LinkModalComponent,
    NoteModalComponent,
    SaveBackActionsComponent,
    NavbarBigComponent,
    NavbarSmallComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    CreateElementButtonsComponent,
    AdminCrudButtonsComponent,
    LoadingComponent,
    isEllipsisActiveDirective,
    CheckPermissionDirective,
    AutoFocus,
    InputComponent,
    ApcSectionAnchorsComponent,
    BasicCrudModalComponent,
    MultiFormsComponent,
    SelectComponent,
    HelpIconComponent,
    HighLightPipe,
    TagInputModule,
    NgxJsonViewerModule,
    DataComponent,
    ProgressBarModule
    ],
  providers: [DatePipe, CurrencyPipe]
})
export class UiModule {}
